import { render, staticRenderFns } from "./MessageListContent.vue?vue&type=template&id=a471763c&"
import script from "./MessageListContent.vue?vue&type=script&lang=js&"
export * from "./MessageListContent.vue?vue&type=script&lang=js&"
import style0 from "./MessageListContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports